<div class="toolbar-container {{ToolbarClass}}">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/toolbar/toolbar.html